import Service from "./apiService";

class PodcastsService extends Service {
  getData(filters = {}, sorters = {}, page = 1, limit = 25) {
    const params = new URLSearchParams();
    params.set("page", String(page || 1));
    params.set("limit", String(limit || 25));
    if (filters && Object.keys(filters).length > 0) {
      params.set("filters", JSON.stringify(filters));
    }
    if (sorters && Object.keys(sorters).length > 0) {
      params.set("sorters", JSON.stringify(sorters));
    }
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `podcasts?${params.toString()}`,
      method: "GET",
    });
  }

  get(id) {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `podcasts/${id}`,
      method: "GET",
    });
  }  

  add(form) {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `podcasts`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(form),
    });
  }

  update(id, form) {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `podcasts/${id}`,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(form),
    });
  }

  delete(id) {
    return super.ajax({
      baseUrl: this.BACKEND_URL,
      path: `podcasts/${id}`,
      method: "DELETE",
    });
  }

}

export var podcastsService = new PodcastsService();
